import { render } from "./ColourOverviewToolbar.vue?vue&type=template&id=ff8def1c"
import script from "./ColourOverviewToolbar.vue?vue&type=script&lang=js"
export * from "./ColourOverviewToolbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__